angular
  .module("myApp")

  .controller(
    "ManagerCalendarController",
    function ($scope, $state, $stateParams, uuiData, Dialog, CalendarEventSave, CalendarEventRemove) {
      $scope.year = $stateParams.year ? parseInt($stateParams.year, 10) : moment().year()
      $scope.month = $stateParams.month ? parseInt($stateParams.month, 10) : moment().month()

      $scope.events = []
      $scope.mode = "month"
      $scope.date = new Date()

      this.goForward = () => {
        if ($scope.month === 11) {
          $state.go("app.calendar", {
            year: $scope.year + 1,
            month: 0,
          })
        } else {
          $state.go("app.calendar", {
            year: $scope.year,
            month: $scope.month + 1,
          })
        }
      }

      this.newEventClicked = () => {
        this.editEvent({
          veids: "PLANOTA",
        })
      }

      this.calendarEventClicked = (e) => {
        this.editEvent(e.dto)
      }

      this.editEvent = (pp) => {
        const p = angular.copy(pp)
        Dialog.dialog("pages/calendar/event.form.html", p, (p, action) => {
          if (action === "delete") {
            return Dialog.finish(new CalendarEventRemove({ id: p.id }), this.reload)
          } else if (action === "save") {
            return Dialog.finish(new CalendarEventSave(p), this.reload)
          }
        })
      }

      this.reload = () => {
        uuiData.list(
          "calendar_events_list",
          (events) => {
            $scope.events = events.map((e) => {
              const d = []
              if (e.darbinieks_1_id) {
                e.darbinieks_1_name = `${e.darbinieks_1_vards} ${e.darbinieks_1_uzvards}`
                d.push(e.darbinieks_1_name)
              }
              if (e.darbinieks_2_id) {
                e.darbinieks_2_name = `${e.darbinieks_2_vards} ${e.darbinieks_2_uzvards}`
                d.push(e.darbinieks_2_name)
              }
              e.datums = moment(e.datums, "YYYY-MM-DD").toDate()
              e.pieteikums_name = `${e.numurs} ${e.nosaukums}`
              return {
                dto: e,
                startsAt: e.datums,
                title: `${e.numurs} ${e.nosaukums} -- ${d.join(", ")}`,
                allDay: true,
                draggable: false,
                resizable: false,
              }
            })
          },
          $scope.failing
        )
      }

      this.viewChangeClicked = (nextView) => {
        if (nextView === "day") {
          return false
        }
      }

      this.reload()
    }
  )

  .controller(
    "PPManagerParbaudesController",
    function ($scope, uuiData, Dialog, CalendarEventSave, CalendarEventRemove) {
      this.editEvent = (pp) => {
        const p = angular.copy(pp)
        Dialog.dialog("pages/calendar/event.form.html", p, (p, action) => {
          if (action === "delete") {
            return Dialog.finish(new CalendarEventRemove({ id: p.id }), this.reload)
          } else if (action === "save") {
            return Dialog.finish(new CalendarEventSave(p), this.reload)
          }
        })
      }

      this.reload = () => {
        uuiData.list(
          "calendar_events_list",
          { pieteikums_id: $scope.dto.pieteikums_id },
          (events) => {
            $scope.dto.parbaudes = events.map((e) => {
              if (e.darbinieks_1_id) {
                e.darbinieks_1_name = `${e.darbinieks_1_vards} ${e.darbinieks_1_uzvards}`
              }
              if (e.darbinieks_2_id) {
                e.darbinieks_2_name = `${e.darbinieks_2_vards} ${e.darbinieks_2_uzvards}`
              }
              e.datums = moment(e.datums, "YYYY-MM-DD").toDate()
              e.pieteikums_name = `${e.numurs} ${e.nosaukums}`
              return e
            })
          },
          $scope.failing
        )
      }

      this.newEventClicked = () => {
        this.editEvent({
          veids: "PLANOTA",
          pieteikums_id: $scope.dto.pieteikums_id,
          pieteikums_name: `${$scope.dto.numurs} ${$scope.dto.nosaukums}`,
        })
      }

      $scope.$on("enter.parbaudes", this.reload)
    }
  )
